module.exports = __webpack_public_path__ + "img/not_found_img_72x72.9da33d48.jpg";